var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('config-title',{attrs:{"title":"Definições"}}),_c('update-password'),_c('update-pin'),_c('section-delete-account'),_c('delete-account'),_c('modal-update-pin')],1)}
var staticRenderFns = []

export { render, staticRenderFns }